var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hl-overlay hl-overlay--light",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "hl-player-card"
  }, [_c('button', {
    staticClass: "hl-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" × ")]), _c('div', {
    staticClass: "hl-player-video"
  }, [_c('video', {
    ref: "player",
    attrs: {
      "playsinline": "",
      "controlslist": "nodownload",
      "poster": _vm.video.thumbnail || '',
      "src": _vm.video.videoUrl || ''
    },
    on: {
      "loadedmetadata": _vm.onLoadedMeta,
      "timeupdate": _vm.onTimeUpdate,
      "play": function ($event) {
        _vm.isPlaying = true;
      },
      "pause": function ($event) {
        _vm.isPlaying = false;
      },
      "ended": function ($event) {
        _vm.isPlaying = false;
      },
      "click": _vm.togglePlay
    }
  }), _c('div', {
    staticClass: "hl-controls"
  }, [_c('button', {
    staticClass: "hl-controls-toggle",
    attrs: {
      "type": "button",
      "aria-label": _vm.isPlaying ? 'Pause' : 'Play'
    },
    on: {
      "click": _vm.togglePlay
    }
  }, [!_vm.isPlaying ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z",
      "fill": "currentColor"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 4h3.5v16H7zM13.5 4H17v16h-3.5z",
      "fill": "currentColor"
    }
  })])]), _c('div', {
    staticClass: "hl-controls-track",
    on: {
      "click": _vm.seek
    }
  }, [_c('div', {
    staticClass: "hl-controls-fill",
    style: {
      width: _vm.progressPercent + '%'
    }
  })]), _c('span', {
    staticClass: "hl-controls-time"
  }, [_vm._v(" " + _vm._s(_vm.formatTime(_vm.currentTime)) + " / " + _vm._s(_vm.formatTime(_vm.duration)) + " ")])])]), _c('div', {
    staticClass: "hl-player-info"
  }, [_c('div', {
    staticClass: "hl-player-meta"
  }, [_c('h4', [_vm._v(_vm._s(_vm.video.title))]), _c('div', {
    staticClass: "hl-meta"
  }, [_c('div', {
    staticClass: "hl-meta-item"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/calender.svg",
      "alt": ""
    }
  }), _c('span', [_c('small', [_vm._v("Event Date")]), _vm._v(" " + _vm._s(_vm.video.eventDate) + " ")])]), _c('div', {
    staticClass: "hl-meta-item"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/clock.svg",
      "alt": ""
    }
  }), _c('span', [_c('small', [_vm._v("Expiry Date:")]), _vm._v(" " + _vm._s(_vm.video.expiryDate) + " ")])])])]), _c('div', {
    staticClass: "hl-player-actions"
  }, [_c('span', {
    staticClass: "gems-badge gems-badge-dark"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/gems.svg",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.video.points) + " ")]), _c('a', {
    staticClass: "hl-btn hl-btn--download",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('download', _vm.video);
      }
    }
  }, [_c('span', [_vm._v("Download")])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }